export default __webpack_public_path__ + "static/media/UNOSAT-white.6b8b530d.png";